import { useEffect, useRef, useState } from 'react'
import { DateRange } from 'react-date-range'
import format from 'date-fns/format'
import { enUS } from 'date-fns/locale'
import { addDays } from 'date-fns'

import { Popover } from '@mui/material'
import 'react-date-range/dist/styles.css'; 
import 'react-date-range/dist/theme/default.css'; 


const DateRangePickerComponent = ({ onChange, clear, value = [] }) => {
  const [range, setRange] = useState([
    {
      startDate: value[0] || null,
      endDate: value[1] || null,
      key: 'selection',
    },
  ])

  const [anchorEl, setAnchorEl] = useState(null)
  const refOne = useRef(null)

  useEffect(() => {
    document.addEventListener('keydown', hideOnEscape, true)
    document.addEventListener('click', hideOnClickOutside, true)
    return () => {
      document.removeEventListener('keydown', hideOnEscape, true)
      document.removeEventListener('click', hideOnClickOutside, true)
    }
  }, [])

  const hideOnEscape = (e) => {
    if (e.key === 'Escape') {
      setAnchorEl(null)
    }
  }

  const hideOnClickOutside = (e) => {
    if (refOne.current && !refOne.current.contains(e.target)) {
      // setAnchorEl(null)
    }
  }

  const handleSelect = (item) => {
    const selectedRange = item.selection
    setRange([selectedRange])

    const formattedRange = [selectedRange.startDate, selectedRange.endDate]
    onChange(formattedRange)
  }

  useEffect(() => {
    if (clear) {
      setRange([
        {
          startDate: null,
          endDate: null,
          key: 'selection',
        },
      ])
    }
  }, [clear])


  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <div className="calendarWrap" ref={refOne}>
      <textarea
        value={
          range[0]?.startDate && range[0]?.endDate
            ? `${format(range[0].startDate, 'dd MMM yyyy')}\n${format(
                range[0].endDate,
                'dd MMM yyyy'
              )}`
            : ''
        }
        readOnly
        rows={2}
        style={{
          width: '100%',
          padding: '3px',
          fontSize: '10px',
          lineHeight: '1.5',
          border: '1px solid #ccc',
          borderRadius: '4px',
          resize: 'none',
          overflow: 'hidden',
          backgroundColor: 'white',
          marginTop: '3px',
          color: 'secondary',
          outline: 'blue',
          textAlign: 'center',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontFamily: 'Quicksand',
        }}
        placeholder="Select Date Range"
        onClick={handleOpen}
      />
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <DateRange
          onChange={handleSelect}
          editableDateInputs={true}
          moveRangeOnFirstSelection={false}
          ranges={range}
          months={1}
          direction="horizontal"
          locale={enUS}
          className="calendarElement"
        />
      </Popover>
    </div>
  )
}

export default DateRangePickerComponent